module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point3_3-9b5764c2a41defd10ddec8df9e983432.jpg";